module.exports = __webpack_public_path__ + "img/bg-home.6b3ea02c.jpg";